import { Injectable } from '@angular/core';
import config from '@config';
import * as Sentry from '@sentry/angular';
import { AnalyticsEvent } from '@services/models/analytics-event';
import { UserService } from '@services/user.service';
import { UserModel } from '@shared/models/user';

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  canTrack() {
    const username = UserService.isLoggedIn() ? UserService.getCurrent().username : null;
    return config.sentry.enabled && (username ? !config.sentry.metricsUsersBlacklist?.includes(username) : true);
  }

  track(key: AnalyticsEvent, attributes: Record<string, any> = {}) {
    if (!this.canTrack()) return;

    Sentry.metrics.count(key, 1, { attributes });
  }

  trackLogin(input: UserModel) {
    const user = { email: input.email, username: input.username, role: input.role };
    Sentry.setUser(user);
    this.track('login', user);
  }

  trackLogout() {
    Sentry.setUser(null);
    this.track('logout');
  }

  trackProcess(key: AnalyticsEvent, properties: Record<string, any> = {}) {
    const startTime = Date.now();
    const onDone = () => {
      if (!this.canTrack()) return;
      Sentry.metrics.gauge(key, Date.now() - startTime, {
        unit: 'millisecond',
        attributes: properties,
      });
    };

    return onDone;
  }
}
